'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('jobadsSubmitCtrl', ['$scope', function($scope){
	
	$scope.form;
	$scope.submitted = false;
	
	$scope.formSubmit = function(e){
		e.preventDefault();
		$scope.submitted = true;
		let is_grecaptcha = $scope.form.find('#g-recaptcha-response-hidden').length > 0;
		if (is_grecaptcha && typeof (grecaptcha) !== 'undefined') {
			grecaptcha.ready(function () {
				grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action: 'submit'}).then(function (token) {
					if (document.getElementById('g-recaptcha-response-hidden')) {
						$('#g-recaptcha-response-hidden').val(token);
					} else {
						var inp = document.createElement('input');
						inp.type = 'hidden';
						inp.name = 'g-recaptcha-response';
						inp.value = token;
						$scope.form[0].appendChild(inp);
					}
					$scope.form[0].submit();
				});
			});
		} else {
			$scope.form[0].submit();
		}
	};
	
}]).directive('jobadsSubmit', function(){
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});